module.exports = __webpack_public_path__ + "static/media/icon_investment-operations.2830e0a9.svg";